import { ATS_SHARED_CANDIDATE_FORM } from './constants';

export const es = {
  [ATS_SHARED_CANDIDATE_FORM]: {
    PUBLISHED: 'Publicado: {{datePublished}}',
    DEADLINE: 'Fecha de cierre: {{deadlineDate}}',
    SPACE: ' | ',
    APPLY: 'Aplicar',
    APPLICATION_FORM: 'Formulario de aplicación',
    WORK_MODE_VIRTUAL: 'Remoto',
    WORK_MODE_ONSITE: 'Presencial',
    WORK_MODE_HYBRID: 'Híbrido',
    CONTRACT_LEARNING: 'Aprendizaje / Prácticas',
    CONTRACT_FIXED: 'Término fijo',
    CONTRACT_INDEFINITE: 'Término indefinido',
    CONTRACT_SERVICE: 'Prestación de servicios / Freelance',
    CONTRACT_WORK: 'Obra labor',
    WORK_SCHEDULE_PART_TIME: 'Tiempo parcial',
    WORK_SCHEDULE_FULL_TIME: 'Tiempo completo',
    NAMES: 'Nombre (s)',
    REQUIRED_ICON: ' *',
    REQUIRED_FIELDS: 'Campos obligatorios',
    LAST_NAME: 'Apellido (s)',
    EMAIL: 'Correo',
    NUMBER_PHONE: 'Número de teléfono',
    DESCRIPTION_PHONE:
      'Agrega tu teléfono solo con números (no paréntesis, guiones ni espacios).',
    COUNTRY: 'País de residencia',
    CURRICULUM: 'Carga tu curriculum',
    CURRICULUM_DESCRIPTION:
      'Carga tu CV en formato PDF con un peso máximo de 5Mb. Asegúrate que el texto sea seleccionable y no una imagen.',
    UPLOAD_ATTACHMENT: 'Cargar archivo',
    LINKEDIN: 'LinkedIn',
    PLACEHOLDER_LINKEDIN: 'URL (Linkedin)',
    REQUIRED_FIELD: 'Campo requerido',
    INVALID_EMAIL: 'Correo inválido',
    MAX_LENGTH_EXCEEDED: 'Máximo de caracteres excedido',
    YES: 'Si',
    NO: 'No',
    SPACE_FOR_TEXT: 'Espacio para escribir un texto',
    SPACE_FOR_NUMERIC: 'Espacio para escribir un número',
    SEND_APPLICATION: 'Enviar aplicación',
    FILE_EXCEEDS_LIMIT:
      'El archivo seleccionado supera el límite de peso permitido de 5mb.',
    ERROR_TO_CREATE_JOB_APPLICANT_PROFILE:
      'Error al crear el perfil de candidato',
    ERROR_PAGE_TITLE_CANDIDATE_FORM: 'Ocurrió un error',
    ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM:
      'Haz clic en el botón para reintentar cargar nuevamente.',
    RETRY: 'Reintentar',
    INVALID_PHONE: 'Número de teléfono inválido',
    CANDIDATE_FORM_STATUS_TITLE_CLOSED: 'La convocatoria ha finalizado',
    CANDIDATE_FORM_STATUS_SUBTITLE_CLOSED: '¡Gracias por tu interés!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_CLOSED:
      'Muy pronto estaremos publicando nuevas oportunidades laborales.',
    CANDIDATE_FORM_STATUS_TITLE_SUCCESS: '¡Hemos recibido tu aplicación!',
    CANDIDATE_FORM_STATUS_SUBTITLE_SUCCESS:
      '¡Gracias por tu interés en trabajar con nosotros!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_SUCCESS:
      'Pronto nos comunicaremos contigo sobre el estado de tu postulación.',
    CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND: 'Formulario no encontrado',
    CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND:
      'Intenta nuevamente en unos minutos',
    EMAIL_VALIDATION_TITLE:
      'Este correo ya ha sido utilizado para esta postulación.',
    EMAIL_VALIDATION_DESCRIPTION:
      'ya ha sido utilizado para este formulario de postulación. Por favor, utiliza un correo diferente.',
    LOADING_SEND_APPLICATION: 'Enviando tu aplicación',
    INVALID_LINKEDIN_URL: 'URL de LinkedIn inválida',
    BANNER_PREVIEW_FORM:
      'Esta vista del formulario es solo informativa, por lo que no permite subir archivos ni enviarlo.',
    LINKEDIN_VALIDATION_TITLE:
      'El link que ingresaste no parece ser un perfil válido de LinkedIn',
    LINKEDIN_VALIDATION_DESCRIPTION:
      'Asegúrate de copiar y pegar una URL completa, como:',
    EMAIL_BLOCKED_VALIDATION_TITLE: 'No puedes postularte a esta vacante',
    EMAIL_BLOCKED_VALIDATION_DESCRIPTION:
      'Tu perfil no está habilitado para postularte a nuevas vacantes en este momento.',
    BACK_TO_FORM: 'Volver al formulario',
    CANDIDATE_SOURCE_TITLE: '¿Cómo te enteraste de esta vacante?',
    CANDIDATE_SOURCE_LINKEDIN: 'LinkedIn',
    CANDIDATE_SOURCE_COMPANY_WEBSITE: 'Página web de la empresa',
    CANDIDATE_SOURCE_REFERRED: 'Referido por un colaborador',
    CANDIDATE_SOURCE_SOCIAL_MEDIA: 'Redes sociales',
    CANDIDATE_SOURCE_OTHER: 'Otros',
    DISABILITY_TITLE: '¿Te reconoces como una persona con discapacidad?',
    DISABILITY_DESCRIPTION:
      'Esta información se usa únicamente para fines de inclusión y accesibilidad en el proceso',
    GENDER_TITLE: '¿Con qué género te identificas?',
    GENDER_DESCRIPTION:
      'Esta información se usa únicamente para fines de inclusión y accesibilidad en el proceso',
    GENDER_FEMALE: 'Femenino',
    GENDER_MALE: 'Masculino',
    GENDER_OTHER: 'Otro / prefiero no especificar',
    CANDIDATE_SOURCE_UPLOAD_MASSIVE: 'Carga masiva',
    INVALID_PHONE_LENGTH:
      'El número de teléfono debe tener entre 5 y 15 dígitos',
    VALIDATION_ERROR:
      'La validación del formulario ha fallado. Por favor, revisa los campos e intenta nuevamente.',
  },
};
